<template>
    <DFormRow
        :label="__('customers.contracts.third_party_cost')"
        :is-required="true"
        :error="errors.third_party_cost"
    >
        <DInput
            :id="`price${idSuffix}`"
            :model-value="modelValue"
            @update:modelValue="updateModelValue"
        />
    </DFormRow>
</template>

<script setup>

defineProps({
    modelValue: {
        type: [String, Number],
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    idSuffix: {
        type: String,
        default: ''
    }
})

const emit = defineEmits(['update:modelValue'])

function updateModelValue (value) {
    emit('update:modelValue', value)
}
</script>
